import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Pagination } from 'antd';
import plus from '../dist/webImages/plus.svg';
import useGet from '../customHooks/useGet';
import SkeletonCustomerCard from './SkeletonCustomerCard';
import CustomerCard from './CustomerCard';

const PAGE_SIZE = 10;

const canAccessCustomerAction = (permission, action) =>
  permission?.Customers?.includes(action) ||
  permission?.Customer?.includes(action);

const Customers = ({ permission }) => {
  const [datas, setDatas] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchInput, setSearchInput] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [paginationn, setPaginationn] = useState({});
  const [resget, apiMethodGet] = useGet();

  useEffect(() => {
    apiMethodGet('customers?page=' + currentPage + '&per_page=' + PAGE_SIZE + '&search=' + encodeURIComponent(searchQuery));
  }, [currentPage, searchQuery]);

  useEffect(() => {
    if (!resget?.isLoading && resget?.data) {
      const responseData = resget?.data?.data;
      const list = Array.isArray(responseData)
        ? responseData
        : Array.isArray(responseData?.data)
          ? responseData?.data
          : [];
      const paginationData = resget?.data?.pagination ?? responseData?.pagination ?? {};

      setDatas(list);
      setPaginationn(paginationData);
    }
  }, [resget?.data, resget?.isLoading]);

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    setCurrentPage(1);
    setSearchQuery(searchInput.trim());
  };

  return (
    <div className='TeamPage pr-10 max-lg:pr-6'>
      <div className='TeamPageTop flex justify-between items-center gap-3 max-lg:flex-col max-lg:items-start'>
        <h6 className='text-[1rem] mb-2 bookingSectionh relative px-3 font-Mluvka capitalize'>
          {resget?.isLoading ? 'Customers' : ((paginationn?.total ?? datas?.length ?? 0) + ' Customers')}
        </h6>
        <div className='flex items-center gap-3 max-lg:w-full max-lg:flex-col max-lg:items-stretch'>
          <form onSubmit={handleSearchSubmit} className='flex items-center gap-2 max-lg:w-full max-lg:flex-col'>
            <input
              type='text'
              value={searchInput}
              onChange={(event) => setSearchInput(event.target.value)}
              placeholder='Search customers'
              className='outline-none w-[18rem] max-lg:w-full h-[3rem] px-5 rounded-full bg-white border border-[#D4DEF1]'
            />
            <button
              type='submit'
              className='bg-[#1C1C1C] text-white px-6 h-[3rem] rounded-full whitespace-nowrap'
            >
              Search
            </button>
          </form>
          {canAccessCustomerAction(permission, 'Customer Add') && (
            <Link
              to='/customers/create'
              className='bg-[#d9dcf8] py-3 px-6 rounded-full flex items-center gap-2 cursor-pointer whitespace-nowrap'
            >
              <img src={plus} alt='plus' />
              <span className='font-MluvkaBold text-white capitalize'>Add customer</span>
            </Link>
          )}
        </div>
      </div>

      <div className='NewsPageGrid mt-4 bg-[#EFF4FD] rounded-3xl p-6 grid grid-cols-1 gap-3 max-lg:p-3'>
        {resget.isLoading
          ? Array.from({ length: 6 }).map((_, index) => (
              <React.Fragment key={index}>
                <SkeletonCustomerCard />
              </React.Fragment>
            ))
          : datas.map((item) => (
              <React.Fragment key={item?.id}>
                <CustomerCard
                  permission={permission}
                  data={item}
                  alldata={datas}
                  deleted={setDatas}
                />
              </React.Fragment>
            ))}
      </div>

      <div className='mt-4'>
        <Pagination
          current={currentPage}
          onChange={setCurrentPage}
          total={paginationn?.total ?? datas?.length ?? 0}
          pageSize={paginationn?.per_page ?? PAGE_SIZE}
        />
      </div>
    </div>
  );
};

export default Customers;
